import React, { useEffect, useRef, useState }   from 'react'
import axios                                    from 'axios'
import { 
   Box,
   Button,
   Grid
}                                               from '@material-ui/core'

import {
   formUpdatedPilotNameCohortSourceEntry,
   getEntry,
   node_server
}                                               from '../Helpers'
import InfoComponent                            from './InfoComponent'
import PilotCohortSourceInputComponent          from './PilotCohortSourceInputComponent'
import PilotCohortSourceReadComponent           from './PilotCohortSourceReadComponent'
import PilotCohortSourceTitleReadComponent      from './PilotCohortSourceTitleReadComponent'
import Typography                               from '@material-ui/core/Typography'

const PilotCohortSourceUpdateComponent = () => {

   /*  */
   const [ entry,                               setEntry                         ]  =  useState([])
   const   myEntryRef                                                               =  useRef(entry);

   /* This is the _id of the sub object being updated, a tableRow in this case */
   const [ entryId,                             setEntryId        ]  =  useState('')
   /* id here is the overall id of the item from the MongoDB collection */
   const [ id,                                  setId                            ]  =  useState('')
   const [ showInfoComponent,                   setShowInfoComponent             ]  =  useState(true)
   const [ triggerUseEffect,                    setTriggerUseEffect              ]  =  useState(-1)

   /* Input Fields */
   const [ cohort,                              setCohort                        ]  =  useState('')
   const [ pilotName,                           setPilotName                     ]  =  useState('')
   const [ source,                              setSource                        ]  =  useState('')

   const info = [
      'This page cannot update Title, or add / delete a pilot row. These operations can currently only be accomplished manually in the MondoDB collection.',
      'A row can be added manually and then updated here, but that enry must have all three fields populated and have an associated _id.'
   ]

   const closeComponent = () => {
      setShowInfoComponent(false)
   }

   const changeCohort = (e) => {
      setCohort(e.target.value)
   }

   const changePilotName = (e) => {
      setPilotName(e.target.value)
   }

   const changeSource = (e) => {
      setSource(e.target.value)
   }

   // Keep the ref in sync whenever state updates
   useEffect(() => {
      myEntryRef.current = entry;
   }, [entry]);

   /* 2. This then gets that object from the MongoDB collection */
   useEffect( () => {

      /* This logical IF keeps the GET from running with a '' value for id which fails. */
      if (id !== '') {
         axios.get(node_server + `pilotCohortSourceTable/${id}`)
            .then( res => {
               setEntry(res.data.table)
            } )
      }
   }, [ id ] )

   /* This takes a click event and records the _id of the Pilot / Cohort / Source Table from the MongoDB pilotcohortsourcetables collection
      via the PilotCohortSourceTitleReadComponent or the _id of the tableRow that was clicked on in the PilotCohortSourceReadComponent.
      The PilotCohortSourceTitleReadComponent sends back the component name for use in the logical IF below.
      Step 1 uses the IF and Step 3 uses the ELSE. */
   const handleClick = (id, component) => {
      if (component === 'PilotCohortSourceTitleReadComponent') {
         setId(id)
      }
      else {
         /* This id is actually the _id of tableRow selected and not the overall collection object */
         setEntryId(id)
         const data = getEntry(myEntryRef.current.tableRow, id)
         setCohort(data.cohort)
         setPilotName(data.pilotName)
         setSource(data.source)
      }
      closeComponent()
   }

   const handleSubmit = () => {
      const data = formUpdatedPilotNameCohortSourceEntry(
         myEntryRef.current.tableRow,
         entryId,
         {
            pilotName: pilotName,
            cohort:    cohort,
            source:    source
         }
      )

      axios.put(node_server + 'pilotCohortSourceTable/updateRow', {
         id,
         tableRow: data
      })
         .then( res => {
            setTriggerUseEffect(triggerUseEffect + 1)
         } )
   }

   return(
      <Box style={{ marginTop: '6rem', marginBottom: '1rem', padding: '2rem' }} >
         <Grid>
            <Typography variant='h4'>
               Pilot / Cohort / Source Update Page
            </Typography>
         </Grid>
         { showInfoComponent ? <InfoComponent closeComponent={closeComponent} info={info} /> : null }
         <Grid>
            {/*           1. This returns the _id of the collection object from MongoDB         3. This then displays the object from MongoDB */}
            { id === '' ? <PilotCohortSourceTitleReadComponent handleClick={handleClick} /> :   <PilotCohortSourceReadComponent handleClick={handleClick} id={id} triggerUseEffect={triggerUseEffect} /> }
            {pilotName === ''
               ?
                  null
               :
                  <PilotCohortSourceInputComponent
                     changeCohort={changeCohort}
                     changePilotName={changePilotName}
                     changeSource={changeSource}
                     singleEntry={{
                        cohort,
                        pilotName,
                        source
                     }}
                  />
            }
            {cohort === '' && pilotName === '' && source === ''
               ?
                  <Grid item xs={2} style={{marginTop: '1rem'}} >
                     <Button data-testid='history-create-submit' variant='contained' color='primary' disabled >Submit</Button>
                  </Grid>
               :
                  <Grid item xs={2} style={{marginTop: '1rem'}} >
                     <Button data-testid='history-create-submit' variant='contained' color='primary' onClick={handleSubmit}>Submit</Button>
                  </Grid>
            }
         </Grid>
      </Box>
   )
}

export default PilotCohortSourceUpdateComponent
